import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-properties',
  templateUrl: './properties-form-field.component.html',
  styleUrls: ['./properties-form-field.component.scss'],
  standalone: false,
})
export class PropertiesFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  prettyJson: string = '';

  ngOnInit() {
    try {
      if (this.data === undefined || this.data === null) {
        this.prettyJson = '';
        return;
      }

      if (typeof this.data === 'string' || this.data instanceof String) {
        try {
          const obj = JSON.parse(`${this.data}`);

          // ok, so we are an object
          this.prettyJson = JSON.stringify(obj, null, 2);
        } catch (err) {
          // so could just be a string
          this.prettyJson = `${this.data}`;
        }
      } else {
        this.prettyJson = JSON.stringify(this.data, null, 2);
      }
    } catch (err) {
      this.prettyJson = `Failed to parse data object: ${this.data}`;
    }
  }

  ngOnDestroy() {}
}
